// Converted to typescript through help of ChatGPT

import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { type resourceStoreTypes, resourceUpserters } from '../core';
import { coreActions } from '../core-actions';
import * as actions from './documentsActions';
import { type Document, type DocumentProps, type DocumentsStore, mkDocumentsStore } from './documentsTypes';

const reducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<DocumentProps>,
  | ReturnType<typeof actions.getDocumentsSuccess>
  | ReturnType<typeof actions.getDocumentsFailure>
  | ReturnType<typeof actions.createDocumentSuccess>
  | ReturnType<typeof actions.createDocumentFailure>
  | ReturnType<typeof actions.deleteDocumentSuccess>
  | ReturnType<typeof actions.deleteDocumentFailure>
>(
  {
    [coreActions.sanitize.toString()]: (state: DocumentsStore) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource: Document) =>
          resource.merge({
            name: hash(resource.name).toString(),
          }),
        ),
      ),

    [combineActions(actions.getDocumentsSuccess).toString()]: (
      // DocumentStore replaced with any to fix tsc errors in QLH
      state: any,
      { payload: data }: { payload: any },
    ) => resourceUpserters.upsertResources(state, data),

    [combineActions(actions.createDocumentSuccess, actions.deleteDocumentSuccess).toString()]: (
      // DocumentStore replaced with any to fix tsc errors in QLH
      state: any,
      { payload: documentToUpsert }: { payload: any },
    ) => resourceUpserters.upsertResource(state, documentToUpsert),

    [combineActions(
      actions.getDocumentsFailure,
      actions.createDocumentFailure,
      actions.deleteDocumentFailure,
    ).toString()]: (
      // DocumentStore replaced with any to fix tsc errors in QLH
      state: any,
      { payload: error }: { payload: any },
    ) => resourceUpserters.completeWithError(state, error),
  },
  mkDocumentsStore(),
);

export default reducer;
